export interface PausableTimer {
  pause: () => void
  resume: () => void
}
export function createPausableTimer(
  callback: () => void,
  duration: number
): PausableTimer {
  let startedAt = Date.now()
  let remaining = duration
  let timer: NodeJS.Timeout | null = setTimeout(callback, duration)

  return {
    pause: () => {
      if (!timer) {
        return
      }

      remaining = remaining - (Date.now() - startedAt)
      clearTimeout(timer)
      timer = null
    },
    resume: () => {
      if (timer) {
        return
      }
      timer = setTimeout(callback, remaining)
      startedAt = Date.now()
    },
  }
}
